"use strict";

var _WeakMap = require("@babel/runtime-corejs3/core-js-stable/weak-map");
var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _bind = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/bind"));
var _promise = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/promise"));
var _react = _interopRequireDefault(require("react"));
var _AuButton = _interopRequireWildcard(require("../elements/AuButton"));
var _AutoIntl = _interopRequireDefault(require("./AutoIntl"));
var _spinner_white = _interopRequireDefault(require("../../images/spinner_white.gif"));
var _context;
function _getRequireWildcardCache(e) { if ("function" != typeof _WeakMap) return null; var r = new _WeakMap(), t = new _WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = _Object$defineProperty && _Object$getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? _Object$getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? _Object$defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
var styles = {
  "image": "processing_button-module__image___n9quv"
};
class ProcessingButton extends _AuButton.default {
  state = {
    processing: false
  };
  handleOnClick = (0, _bind.default)(_context = this.handleOnClick).call(_context, this);
  handleOnClick(e) {
    this.setState({
      processing: true
    }, () => _promise.default.resolve(super.handleOnClick(e)).then(() => this.setState({
      processing: false
    })));
  }
  render() {
    const {
      processing
    } = this.state;
    if (!processing) {
      return super.render();
    }
    return this.renderContent({
      ...this.props,
      displayId: undefined /* hide original label */,
      displayString: undefined /* hide original label */,
      disabled: true,
      type: _AuButton.BUTTON_TYPE_INACTIVE,
      children: [/*#__PURE__*/_react.default.createElement("img", {
        src: _spinner_white.default,
        key: "processing_btn_img",
        className: styles.image
      }), /*#__PURE__*/_react.default.createElement(_AutoIntl.default, {
        displayId: "au.processing",
        key: "processing_btn_label"
      })]
    });
  }
}
exports.default = ProcessingButton;